import { MdCloudUpload } from 'react-icons/md';
import { Heading, Icon, IconContainer } from '@nbirl/nbi-common-ui-libs';

export const EmptyUploads = () => (
  <div className="flex flex-col items-center space-y-2 mt-36">
    <IconContainer variant="light">
      <Icon icon={<MdCloudUpload className="text-primary-500" />} />
    </IconContainer>

    <Heading className="text-center text-gray-700">
      No uploads in progress
    </Heading>

    <p className="text-center">Select files you would like to upload.</p>
  </div>
);
